var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCheckmarkIcon = function SvgCheckmarkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4 10L3.848 7.45a.849.849 0 00-1.2 1.2L6.8 12.8l6.603-8.156a.886.886 0 00.197-.558v-.059a.827.827 0 00-1.447-.547L6.4 10z",
    fill: "#75A53E"
  })));
};
export default SvgCheckmarkIcon;